<template>
  <div class="integration">
    <AppSelect
      v-model="data.range"
      :loading="loading"
      :options="list"
      :label="$t('label.range')"
      :rules="[rules.REQUIRED]"
      emit-value
      map-options
    />
    <AppToggle
      v-model="data.addHeaders"
      :label="$t('label.addHeaders')"
      left-label
    />
  </div>
</template>

<script>
import AppSelect from 'common/components/AppSelect';
import AppToggle from 'common/components/AppToggle';
import handleError from 'common/helpers/handleError';
import { autoresponderMixin } from 'common/mixins';

export default {
  name: 'GoogleSpreadSheets',
  components: { AppSelect, AppToggle },
  mixins: [autoresponderMixin],
  data() {
    return {
      data: {
        type: ENUMS.AUTORESPONDER_TYPES.GOOGLE_SPREADSHEETS,
        range: undefined,
        addHeaders: true,
      },
      loading: false,
      list: [],
    };
  },
  created() {
    this.fetch();
    this.data.range = this.value?.data?.range;
    this.data.addHeaders = this.value?.data?.addHeaders;
  },
  methods: {
    async fetch() {
      try {
        this.loading = true;
        this.list = [];
        const { data } = await this.$axios.get(`autoresponders/${this.value.autoresponderProviderId}/external`);
        this.list = data.data.range;
      } catch (error) {
        handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
